<div id="main-container" class="main-container">
  <div class="main-header">
    <img src="/assets/images/Logo.png" height="60px" alt="HS Logo" />
    <div class="btnClass">
      <button type="submit" (click)="NavigateRegister()" class="SignUp">SIGN UP</button>&nbsp;
      <button type="submit" (click)="NavigateLogIn()" class="LogIn">LOG IN</button>
    </div>
  </div>

  <div class="main-body1">
    <img src="/assets/images/HeroImage.png" height="200px" alt="Logo" />
    <div class="body-content">
      Health Slice
      <br />
      Build. Launch. Monitor
      <br />
      <div class="txt">Revolutionize health assessments, surveys and industry standard templates.</div>
      <br/>
      <button type="submit" (click)="NavigateRegister()" class="SignUp">SIGN UP TODAY</button>
    </div>
  </div>

 
  <div class="main-body2">
    <!-- -->
    <div class="flex-col1">
      <img src="assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
      <div class="card-container">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="heading">Out of the box Templates</div>
          Library of health assessment forms and industry standard templates that can be used as-is or can be easily customized by business users.
        </div>
      </div>

      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
      <div class="card-container">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="heading">Securely collect & analyze responses</div>
          Secure tool for data collection with out of the box feature for analysis and secure third party integration.
        </div>
      </div>

      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
      <!--<div class="card-container">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="heading">Business user friendly</div>
          Business users can directly design and publish assessments.
        </div>
      </div>-->

    </div>
    <div class="flex-col2">
      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
      <div class="card-container">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="heading">Create and manage version</div>
            Existing survey design can be utilized to publish new versions.
        </div>
      </div>
      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
      <div class="card-container">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="heading">Business user friendly</div>
          Business users can directly design and publish assessments.
          </div>
        </div>
      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
    </div>
    <div class="flex-col3">
      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
      <!--<div class="card-container">
        <div class="card-header"></div>
        <div class="card-body">Lorem Ipsum Dolor Lorem Ipsum</div>
      </div>-->
      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
      <!--<div class="card-container">
        <div class="card-header"></div>
        <div class="card-body">Lorem Ipsum Dolor Lorem Ipsum</div>
      </div>-->
      <img src="/assets/images/Logo Transparent.png" height="50px" width="120px" alt="Logo" />
    </div>
  </div>
</div>
